
import { Component, Watch } from 'vue-property-decorator'
import { Action, Getter } from "vuex-class";
import { ChartOptions } from "chart.js";
import ChipsRate from '@/shared/bookings/components/ChipsRate.vue';

import Base from "../../core/components/Base.vue";
import { CompleteStats } from "../model/statistics/CompleteStats";

import { BookingConfiguration } from "../model/BookingConfiguration";

import { Slot } from '../model/Slot';

import DoughnutChart from './charts-components/Doughnut.vue'
import BarChart from "./charts-components/BarChart.vue";
import BarLineComboChart from './charts-components/BarLineComboChart.vue';
import NoShowDoughnut from "./charts-components/NoShowDoughnut.vue";
import LiveBookingsDoughnut from "./charts-components/LiveBookingsDoughnut.vue";
import LineChartNoShowRatio from './charts-components/LineChartNoShowRatio.vue';
import { displayNextSlot } from '../tools/booking.stats.tools';

@Component({
    components: { DoughnutChart, BarChart, NoShowDoughnut, LiveBookingsDoughnut, BarLineComboChart, LineChartNoShowRatio, ChipsRate }
})
export default class BookingStats extends Base {

    @Getter('bookingStatistics', { namespace: 'booking' }) bookingStatistics!: CompleteStats;

    @Getter('bookingConfiguration', { namespace: 'booking' }) bookingConfiguration!: BookingConfiguration;

    @Action('a-set-booking-statistics', { namespace: 'booking' }) getBookingStatistics!: (
        customerId: string) => void;

    @Action('a-set-bookings', { namespace: 'booking' }) getBookings!: (
        customerId: string) => void;

    @Watch("$store.state.booking.bookingStatistics.today.p1")
    handleStatsChange() {
        this.updateFilter()
    }

    get slotsSite() {
        return this.$store.state.booking.bookingConfiguration.slots;
    }

    get slotSelection(): string[] {
        return this.slotsSite.map((slot: Slot): string => {
            return ` ${slot.startTime} - ${slot.endTime}`
        })
    }

    overlay = false;

    expand = false;

    periods: string[] = ["Aujourd'hui", "Hier", "Cette semaine", "Ce mois", "Cette année"];

    selectedItem: string | null = 'Aujourd\'hui';

    activeTooltip: number | null = null;

    bookingStatIsolate = this.bookingStatistics

    propPeriod = 'Aujourd\'hui';

    totalBookingSelected = 0;

    noShowSelected = 0;

    dataSelected: any | null = null;

    slotSelected: string = this.slotSelection.at(0) || 'aucun service trouvé';

    slotIndexSelected = this.slotSelection.indexOf(this.slotSelected);

    isUniqueSlot = !(this.slotsSite.length - 1);

    optionsBooking: ChartOptions = {
        responsive: true,
        maintainAspectRatio: false,
        plugins: {
            legend: {
                position: 'top',
                labels: {
                    font: {
                        size: 18
                    }
                }
            },
            title: {
                display: true,
                text: 'Gestion des réservations',
                // font: {
                //         size: 24
                //     }
            }
        }
    }

    async mounted() {
        this.isUniqueSlot = !(this.slotsSite.length - 1)
        this.selectedItem = this.periods.at(0) || ''
        this.slotSelected = this.displaySlotTime(displayNextSlot(this.slotsSite))
        this.slotIndexSelected = this.slotSelection.indexOf(this.slotSelected)
        this.dataSelected = this.getSlotStats()
        this.totalBookingSelected = this.dataSelected.at(0).totalBooking
        this.noShowSelected = this.dataSelected.at(0).validBooking - this.dataSelected.at(0).completedBooking
    }

    toggleTooltip(n: number): void {
        this.activeTooltip = this.activeTooltip === n ? null : n;
        this.overlay = !this.overlay;
    }

    displaySlotTime(slot: Slot | null | undefined) {
        if (slot === null || slot === undefined) {
            return "aucun service trouvé"
        }
        return ` ${slot.startTime} - ${slot.endTime}`
    }

    updateFilter() {
        this.slotIndexSelected = this.slotSelection.indexOf(this.slotSelected)
        this.propPeriod = this.selectedItem || "Aujourd'hui"
        this.dataSelected = this.getSlotStats()
        const totalBooking = this.selectStat(['p1', this.slotIndexSelected, 'totalBooking'])
        const completed = this.selectStat(['p1', this.slotIndexSelected, 'completedBooking'])
        const validBookings = this.selectStat(['p1', this.slotIndexSelected, 'validBooking'])

        this.totalBookingSelected = totalBooking
        this.noShowSelected = validBookings - completed
    }

    pluginPeriod() {
        switch (this.selectedItem) {
            case "Aujourd'hui":
                return 'today'
            case "Hier":
                return 'yesterday'
            case 'Cette semaine':
                return 'week'
            case 'Ce mois':
                return 'month'
            case 'Cette année':
                return 'year'
            default:
                return 'today'
        }
    }

    getSlotStats() {
        const periodStat = this.bookingStatistics[this.pluginPeriod()]
        return [periodStat.p1.at(this.slotIndexSelected), periodStat.p2.at(this.slotIndexSelected)]

    }

    /**
     * 
     * @param path 
     *? cette fonction permet de parcourir et sélectionner la statistique souhaitée,
     * il faut renseigner le path ['p1', slotIndex, 'totalBokingSeats' ]
     * attention on commence par la période (P1 ou P2), pas par la période (year, month..) qui est renseignée par la propriété selectedPeriod du filtre
     * */
    selectStat(path: (string | number)[]): any {
        path.unshift(this.pluginPeriod())
        return path.reduce((acc: any, key) => typeof key === 'string' ? acc?.[key] : acc.at(key), this.bookingStatistics)
    }

    refreshStatsAndData(): void {
        if (this.site?.customerId) {
            this.startLoading()
            this.getBookingStatistics(this.site?.customerId)
            this.getBookings(this.site?.customerId)
            this.releaseLoading()
        }
    }


}
